// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Niger from '../_raw/flag/icon_flag_niger.png';

export default () => <img src={Niger} alt="Niger" />;
